module.exports = __webpack_public_path__ + "img/en-fondi-eu_white.f53f4670.png";